import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, IHydratable, Lmid } from "@/types"
import { printPeriod } from "utils/utils"

export interface IGetInvoiceDraftAssetDto {
    assetId: Guid
    releaseDate?: string | null
    start: string
    end?: string | null
}

export default class InvoiceDraftAsset implements IHydratable {
    assetId: Guid
    releaseDate?: Dayjs
    start: Dayjs
    end?: Dayjs

    articleId?: Guid
    articleDescription?: string
    altArticleDescription?: string
    lmid?: Lmid

    constructor(dto: IGetInvoiceDraftAssetDto) {
        this.assetId = dto.assetId
        this.releaseDate = dto.releaseDate ? dayjs(dto.releaseDate) : undefined
        this.start = dayjs.utc(dto.start)
        const end = dto.end ? dayjs.utc(dto.end) : undefined
        this.end = end?.year() === 9999 ? undefined : end
    }

    get isHydrated(): boolean {
        return !!this.articleId
            && !!this.articleDescription
            && !!this.lmid
    }

    get daysInUse(): number | undefined {
        return (this.end?.diff(this.start, 'days') ?? 0) + 1
    }

    printPeriod(): string {
        if (!this.start && !this.end) return ""
        return printPeriod({
            start: this.start,
            end: this.end,
        })
    }
}
